import React, {lazy} from 'react';
import {Route, Redirect} from "react-router-dom";
import Login from "../NavItems/Login.react";
import SettingsPage from "../../../Pages/SettingsPage.react";
import Dashboard from "../../../Pages/Dashboard.react";
import ReportsPage from "../../../Pages/ReportsPage.react";
import TenantSelection from "../../../Pages/TenantSelection.react";
import EnterpriseTransactions from "../../../Pages/EnterpriseTransactions.react";
import TransactionDetails from "../../../Pages/TransactionDetails.react";
import HoldingsPage from "../../../Pages/HoldingsPage.react";
import CustomReportsPage from "../../../Pages/CustomReportsPage.react";
import ChartAccountsPage from "../../../Pages/ChartAccountsPage.react";
import TaxesPage from "../../../Pages/TaxesPage.react";
import ReconcileTransactionsPage from "../../../Pages/ReconcileTransactionsPage.react";
import {LoginCallback, SecureRoute} from "@okta/okta-react";

const CustomerSearchPage = lazy(() => import("../../../Pages/Customers.react"));
const CustomerRoutes = lazy(() => import("./CustomerRoutes.react"));

const Routes = () => {
  return (
    <div className={'content-container'}>
      <Route exact path={"/"}>
        <Login />
        <Redirect to='/customers' />
      </Route>
      <Route path={"/login/callback"}>
        <LoginCallback/>
      </Route>
      <SecureRoute exact path={"/customers"}>
        <CustomerSearchPage />
      </SecureRoute>
      <SecureRoute path={"/customers/:id"}>
        <CustomerRoutes />
      </SecureRoute>
      <SecureRoute path={"/settings"}>
        <SettingsPage />
      </SecureRoute>
      <SecureRoute exact path={"/dashboard"}>
        <Dashboard />
      </SecureRoute>
      <SecureRoute exact path={"/holdings"}>
        <HoldingsPage />
      </SecureRoute>
      <SecureRoute exact path={"/reports"}>
        <ReportsPage />
      </SecureRoute>
      <SecureRoute exact path={"/reports/custom"}>
        <CustomReportsPage />
      </SecureRoute>
      <SecureRoute path={"/tenants"}>
        <TenantSelection />
      </SecureRoute>
      <SecureRoute exact path={"/transactions"}>
        <EnterpriseTransactions />
      </SecureRoute>
      <SecureRoute path={"/transactions/:id"}>
        <TransactionDetails />
      </SecureRoute>
      <SecureRoute path={"/accounting"}>
        <ChartAccountsPage />
      </SecureRoute>
      <SecureRoute path={"/taxes"}>
        <TaxesPage />
      </SecureRoute>
      <SecureRoute path={"/reconcile-transactions"}>
        <ReconcileTransactionsPage />
      </SecureRoute>
    </div>
  )
}

export default Routes;
